import { Box, Table, TableBody } from '@mui/material';

import { Shimmer } from './Shimmer';
import { TableSkeleton } from './TableSkeleton';

/**
 * Whole-page placeholder for the student / installment detail screen: back link,
 * title, the two-row summary card, then the transaction table. Mirrors
 * StudentDetailPage's 2-up (xs) / 4-up (md) summary grid.
 */
export const DetailPageSkeleton = () => (
  <Box sx={{ display: 'flex', flexDirection: 'column', gap: '20px', pt: '10px' }}>
    <Shimmer height={14} width={120} />

    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '9px' }}>
      <Shimmer height={{ xs: 20, sm: 22, md: 24 }} width={{ xs: '55%', sm: 220 }} />
      <Shimmer height={14} width={{ xs: '75%', sm: 280 }} />
    </Box>

    {/* Summary card — two rows of four fields. */}
    <Box
      sx={(theme) => ({
        bgcolor: 'white',
        border: `1px solid ${theme.palette.grey[200]}`,
        borderRadius: '16px',
        boxShadow: '0px 1px 3px rgba(0,0,0,0.06)',
        p: { xs: '16px', sm: '24px' },
        display: 'flex',
        flexDirection: 'column',
        gap: '24px',
      })}
    >
      {[0, 1].map((row) => (
        <Box
          key={row}
          sx={{ display: 'grid', gridTemplateColumns: { xs: 'repeat(2, 1fr)', md: 'repeat(4, 1fr)' }, gap: '20px' }}
        >
          {Array.from({ length: 4 }, (_, i) => (
            <Box key={i} sx={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
              <Shimmer height={11} width="60%" />
              <Shimmer height={15} width="80%" />
            </Box>
          ))}
        </Box>
      ))}
    </Box>

    {/* History card */}
    <Box
      sx={(theme) => ({
        bgcolor: 'white',
        border: `1px solid ${theme.palette.grey[200]}`,
        borderRadius: '16px',
        boxShadow: '0px 1px 3px rgba(0,0,0,0.06)',
        overflow: 'hidden',
      })}
    >
      <Box
        sx={(theme) => ({
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          px: { xs: '16px', sm: '24px' },
          py: '16px',
          borderBottom: `1px solid ${theme.palette.grey[200]}`,
        })}
      >
        <Shimmer height={28} width={28} radius="50%" />
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '5px', flex: 1, minWidth: 0 }}>
          <Shimmer height={14} width={{ xs: '50%', sm: 150 }} />
          <Shimmer height={11} width={{ xs: '30%', sm: 80 }} />
        </Box>
      </Box>

      <Box sx={{ overflowX: 'auto' }}>
        <Table sx={{ minWidth: 720 }}>
          <TableBody>
            <TableSkeleton columns={8} rows={5} />
          </TableBody>
        </Table>
      </Box>
    </Box>
  </Box>
);
